import "./Testimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../assetsprogressive/button.png";
import symbol from "../assetsprogressive/symbol.png";
import f1 from "../assetsprogressive/pic1.png";
import f2 from "../assetsprogressive/pic2.png";
import f3 from "../assetsprogressive/pic3.png";
import f4 from "../assetsprogressive/pic4.png";
const Feedback = () => {
  const data = [
     {
       id: 1,
       image: f1,
       name: "Rohan Malhotra",
       position: "— Bengaluru, India",
       feedback:
         "We required a performance-focused PWA that stayed reliable even during peak traffic hours. The final product we received from BastionEx exceeded expectations—smooth performance, great responsiveness, and zero downtime during peak hours.",
     },
     {
       id: 2,
       image: f2,
       name: "Ankita Sharma",
       position: "– New Delhi, India",
       feedback:
         "We were looking for a solution that offered the convenience of an app, minus the complexity of native builds. The PWA we received loads instantly and works even when our field team has weak network coverage.",
     },
     {
       id: 3,
       image: f3,
       name: "Kunal Deshpande",
       position: "– Pune, India",
       feedback:
         "The development process was clear, structured, and transparent. Every feature—from caching to offline mode—was implemented exactly the way our users needed it.",
     },
     {
       id: 4,
       image: f4,
       name: "Meera Pillai",
       position: "— Kochi, India",
       feedback:
         "Our customer engagement improved noticeably after the PWA launch. Faster load times and push notifications helped us re-engage users in a way we couldn’t earlier.",
     },
   ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id='progressive-testimonials' className="progressive-wrapper">
       <div className="container-main">
            <h2 className="heading">
           Hear From Our Customers

            </h2>
            {/* <p className="subHeading">
            We build trust through proven client experiences, delivering reliable CRM solutions that drive measurable results and long-term business growth.
            </p> */}
            <Slider {...settings}>
                {data.map((item) => {
                    return (
                        <div className="fwrapper" key={item.id}>
                            <div className="fbox">
                                <div className="symbolbox">
                                    <img src={symbol} alt="" className="symbolimage" />
                                </div>
                                <div className="fcontent">
                                    <p>{item.feedback}</p>
                                    <div className="personinfo">
                                        <h3>{item.name}</h3>
                                        <h4>{item.position}</h4>
                                    </div>
                                </div>
                                <div className="profilebox">
                                    <img src={item.image} alt="" className="profileimage" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
    </div>
</div>
  );
};

export default Feedback;
